// removed by extract-text-webpack-plugin
module.exports = {"pagination":"_3KdCqe5WuKxM_G06_khk8i","text-center":"_1NWEC_yhECMQsWgSWrb51N"};


//////////////////
// WEBPACK FOOTER
// ./components/Redemption/style.less
// module id = 1234
// module chunks = 0